module.exports = __webpack_public_path__ + "media/hyena.29861d54.mp3";